import { CURRENT_USER } from './homeModel';
import type { ProjectSummary, ShareProjectInput } from './types';

export type ShareRole = 'read' | 'write';
export type ShareProfile = ShareRole | 'owner';
export const SHARE_DIRECTORY = ['Camille Martin', 'Julien Bernard', 'Sophie Leroy', 'Thomas Petit'];
export const SHARE_ROLE_LABEL: Record<ShareProfile, string> = {
  owner: 'Propriétaire', write: 'Peut modifier', read: 'Peut consulter',
};

export function isShareProjectInput(input: unknown): input is ShareProjectInput {
  return !!input && typeof input === 'object' && 'name' in input && 'role' in input && 'profile' in input
    && typeof input.name === 'string' && SHARE_DIRECTORY.includes(input.name)
    && (input.role === 'read' || input.role === 'write')
    && (input.profile === 'owner' || input.profile === 'write' || input.profile === 'read');
}

export function sharingProfile(project: ProjectSummary): ShareProfile {
  const preview = new URLSearchParams(window.location.search).get('as');
  if (preview === 'owner' || preview === 'write' || preview === 'read') return preview;
  return project.owner === CURRENT_USER ? 'owner' : project.memberRoles?.[CURRENT_USER] ?? 'read';
}

export function canShare(project: ProjectSummary, profile?: string | null): boolean {
  if (profile === 'owner' || profile === 'write') return true;
  if (profile === 'read') return false;
  return project.owner === CURRENT_USER || project.memberRoles?.[CURRENT_USER] === 'write';
}
